import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NativeElementWithAction32yo3q41a36ui as NativeElementWithAction } from '../InteractiveElement.mjs';
import { FutureElement3o36ukl4wk2br as FutureElement } from '../NativeElement.commonHtml.js.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KeyCodes_instance1xpu3tad1ataj as KeyCodes_instance } from '../../models/KeyCode.commonHtml.mjs';
import { vpropka48um9uweps as vprop } from './helpers.commonHtml.mjs';
import { KeyboardHints3coyq4x1rsbe3 as KeyboardHints } from '../../models/data.mjs';
import {
  textAreaDriverValues54empem3xft as textAreaDriverValue,
  textAreaDriverActions3fx3qfsuocpnn as textAreaDriverActions,
} from './DriverOverrides.mjs';
import { plus2m1vv33moko5t as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function TextArea$content$lambda($this$vprop) {
  // Inline function 'com.lightningkite.kiteui.views.valueString' call
  var tmp = $this$vprop.attributes_1.native_1.value;
  var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function TextArea$content$lambda_0($this$vprop, it) {
  // Inline function 'com.lightningkite.kiteui.views.valueString' call
  $this$vprop.attributes_1.native_1.value = it;
  return Unit_instance;
}
var TextAreaClass;
function TextArea() {
  if (TextAreaClass === VOID) {
    class $ extends NativeElementWithAction() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'div';
        this.native_1.classes_1.add_utx5q5_k$('textarea-container');
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new (FutureElement())();
        this_0.tag_1 = 'textarea';
        this_0.classes_1.add_utx5q5_k$('editable');
        this_0.classes_1.add_utx5q5_k$('kui');
        // Inline function 'com.lightningkite.kiteui.views.resize' call
        this_0.style_1.native_1.resize = 'none';
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var tmp0_safe_receiver = this_0.element_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keydown', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_enter_iqxcq7_k$() && !it.shiftKey && !(this.action_1 == null)) {
              var tmp0_safe_receiver = this.action_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.startAction_u0zgbm_k$(this);
              }
              it.preventDefault();
              it.stopImmediatePropagation();
            }
            return Unit_instance;
          });
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp_1 = this_0.eventsBack_1['on' + 'keydown'];
          var old = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
          var tmp_2 = 'on' + 'keydown';
          this_0.eventsBack_1[tmp_2] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_enter_iqxcq7_k$() && !it.shiftKey && !(this.action_1 == null)) {
              var tmp0_safe_receiver_0 = this.action_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.startAction_u0zgbm_k$(this);
              }
              it.preventDefault();
              it.stopImmediatePropagation();
            }
            return Unit_instance;
          };
        }
        this.native_1.appendChild_gtildm_k$(this_0);
        tmp.textarea_1 = this_0;
        var tmp_3 = this;
        var tmp_4 = TextArea$content$lambda;
        tmp_3.content_1 = vprop(this.textarea_1, 'input', tmp_4, TextArea$content$lambda_0);
        this.content_1.addListener_6y9mct_k$(() => {
          this.native_1.setAttribute_j9pxft_k$('data-replicated-value', this.content_1.get_value_j01efc_k$());
          return Unit_instance;
        });
        this.keyboardHints_1 = new (KeyboardHints())();
        this.hint_1 = '';
      }
      get_driverValue_yh5neo_k$() {
        return textAreaDriverValue(this);
      }
      get_driverActions_8jqr2k_k$() {
        return plus(super.get_driverActions_8jqr2k_k$(), textAreaDriverActions(this));
      }
      set_hint_qdfs9y_k$(value) {
        this.hint_1 = value;
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        this.textarea_1.attributes_1.native_1.placeholder = value;
      }
    }
    initMetadataForClass($, 'TextArea');
    TextAreaClass = $;
  }
  return TextAreaClass;
}
//region block: exports
export {
  TextArea as TextArea6va0jt1dj0tc,
};
//endregion

//# sourceMappingURL=TextArea.commonHtml.mjs.map
